export class RevenueByCategorySelectors {
  static billedRevenueDonut = 'billedRevenueDonut';
  static earnedRevenueDonut = 'earnedRevenueDonut';
}